import {
  Compiler,
  createNgModuleRef,
  Injectable,
  Injector,
  NgModuleRef,
  ViewContainerRef,
} from "@angular/core";
import { LoadChildrenCallback } from "@angular/router";

@Injectable({
  providedIn: "root",
})
export class LoaderService {
  constructor() {}

  loadComponent(args: {
    loader: LoadChildrenCallback;
    component: string;
    container: ViewContainerRef;
    data: any;
  }) {
    return (args.loader() as Promise<any>).then((module) => {
      const component = module[args.component];
      let { instance }: any = args.container.createComponent(component);
      instance.data = args.data;
    });
  }

  loadModule(args: {
    loader: LoadChildrenCallback;
    module: string;
    container: ViewContainerRef;
    data: any;
    injector: Injector;
    compiler?: Compiler;
  }) {
    return (args.loader() as Promise<any>).then((module) => {
      const lazymodule = module[args.module];
      let moduleRef: NgModuleRef<any>;
      if (args.compiler) {
        const moduleFactory = args.compiler.compileModuleSync(lazymodule);
        moduleRef = moduleFactory.create(args.injector);
      } else {
        moduleRef = createNgModuleRef(lazymodule, args.injector);
      }
      const component = moduleRef.instance.getComponent();
      let { instance }: any = args.container.createComponent(component, {
        ngModuleRef: moduleRef,
      });
      instance.data = args.data;
    });
  }
}
